export default __webpack_public_path__ + "static/media/icon-sales-order.c9ac84c2.svg";